<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { AccordionContent, type AccordionContentProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<AccordionContentProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <AccordionContent
    v-bind="forwardedProps"
    class="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden transition-all"
  >
    <div :class="cn('pb-4', props.class)">
      <slot />
    </div>
  </AccordionContent>
</template>
